import type { PlacementDataSource } from '~/api/data-source/placement';
import { placementDataSource } from '~/api/data-source/placement';
import type { OAISchema } from '~/types/openapi';

// Response 타입
type NavigationBar = OAISchema['PlacementNavigationBarResponse'][];

export interface PlacementRepository {
  getNavigationBars(businessId: number): Promise<NavigationBar>;
}

export class PlacementRepositoryImpl implements PlacementRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: PlacementDataSource = placementDataSource,
  ) {}

  async getNavigationBars(businessId: number) {
    return this.dataSource.getNavigationBars(businessId);
  }
}

export const placementRepository = new PlacementRepositoryImpl();
